import script from "./router-transition.vue?vue&type=script&lang=ts&name=router-transition&setup=true"
export * from "./router-transition.vue?vue&type=script&lang=ts&name=router-transition&setup=true"

import "./router-transition.vue?vue&type=style&index=0&id=14b23734&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b23734"]])

export default __exports__